/* JS Personalizado, no es parte del tema Refresh */
/* Este JS activa la animación del header para hacerlo más moderno */

document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".header-wrapper");
  if (!header) return;

  window.addEventListener("scroll", () => {
    header.classList.toggle("is-scrolled", window.scrollY > 50);
  });
});